module.exports = __webpack_public_path__ + "media/images/workplace/no_jobs_img-002511841771483b56dcb579b3939084.svg";